// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide, .swiper-slide .homePage {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--color-default);
  z-index: 100;
}

.swiper-slide img, .swiper-slide video {
  display: block;

  width: 100%;
  height: 100%;

  -o-object-fit: contain;

     object-fit: contain;
}

.swiper-slide-active:after {
  animation:
    var(--screensaver-animation-duration) linear fade-out forwards,
    var(--screensaver-animation-duration) linear var(--screensaver-animation-out-delay) fade-in forwards;

  content: '';

  position: absolute;

  top: 0;
  left: 0;

  height: 100%;
  width: 100%;

  background-color: var(--color-default);

  z-index: 200;
  pointer-events: none;
}

@keyframes fade-out {
  from { opacity: 1; }
  to { opacity: 0; }
}

@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Screensaver/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,sBAAmB;;KAAnB,mBAAmB;AACrB;;AAEA;EACE;;wGAEsG;;EAEtG,WAAW;;EAEX,kBAAkB;;EAElB,MAAM;EACN,OAAO;;EAEP,YAAY;EACZ,WAAW;;EAEX,sCAAsC;;EAEtC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB","sourcesContent":[".swiper {\n  width: 100%;\n  height: 100%;\n}\n\n.swiper-slide, .swiper-slide .homePage {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: var(--color-default);\n  z-index: 100;\n}\n\n.swiper-slide img, .swiper-slide video {\n  display: block;\n\n  width: 100%;\n  height: 100%;\n\n  object-fit: contain;\n}\n\n.swiper-slide-active:after {\n  animation:\n    var(--screensaver-animation-duration) linear fade-out forwards,\n    var(--screensaver-animation-duration) linear var(--screensaver-animation-out-delay) fade-in forwards;\n\n  content: '';\n\n  position: absolute;\n\n  top: 0;\n  left: 0;\n\n  height: 100%;\n  width: 100%;\n\n  background-color: var(--color-default);\n\n  z-index: 200;\n  pointer-events: none;\n}\n\n@keyframes fade-out {\n  from { opacity: 1; }\n  to { opacity: 0; }\n}\n\n@keyframes fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
